/*
 * Copyright (c) 2023 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyNewsletterController', DinghyNewsletterController);

    DinghyNewsletterController.$inject = ['$http', 'Principal'];

    function DinghyNewsletterController($http, Principal) {
        var vm = this;
        vm.action = action;
        vm.sendMail = {
            startId: 0
        };
        vm.year = new Date().getFullYear();

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/dinghy-events/presence-newsletter/', vm.sendMail).then(function() {
                vm.isSaving = false;
            });
        }
    }
})();
